import api from "@/config/api"
import { withLoading } from "@/store/helpers"

export default {
  namespaced: true,
  state: () => ({
    logs: [],
    pagination: {
      page: 1,
      per_page: 20,
    },
    loading: false,
  }),
  mutations: {
    setLogs(state, logs) {
      state.logs = logs
    },
    setPagination(state, payload) {
      state.pagination = payload
    },
    setLoading(state, loading) {
      state.loading = loading
    }
  },
  actions: {
    async fetchLogs(context) {
      withLoading(async () => {
        const params = {
          pagination: {
            page: context.state.pagination.page,
            per_page: context.state.pagination.per_page
          }
        }
        const response = await api.get("/manage/action_logs", { params })
        context.commit("setLogs", response.data)
      }, context)
    }
  }
}
